import { identityApi } from '../api/config';

interface OneSchemaJWTResponse {
  jwt: string;
}

/**
 * Fetches the OneSchema platform JWT from the Identity API.
 * This token is used to authenticate with the OneSchema service.
 */
export const fetchOneSchemaPlatformToken = async (): Promise<string> => {
  try {
    const response = await identityApi.get<OneSchemaJWTResponse>(
      '/oneschema/jwt'
    );

    if (response.data && response.data.jwt) {
      console.log('Successfully fetched OneSchema JWT from Identity API');
      return response.data.jwt;
    }

    throw new Error(
      'OneSchema JWT not found in API response from Identity API'
    );
  } catch (error) {
    console.error(
      'Failed to fetch OneSchema platform token from Identity API:',
      error
    );
    // Propagate the error so the caller (e.g., Redux thunk) can handle it.
    // This allows for displaying user-facing error messages or retrying.
    throw error;
  }
};
